import { environment } from './../../environments/environment';
import { ToastType } from './../toast/toast.enum';
import { GiftSelection } from './../gift/giftSelection';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { RegistryFirebaseService } from './registry-firebase.service';
import { Injectable } from '@angular/core';
import { Gift } from '../gift/gift';
import { ConfigurationService } from '../shared/configuration.service';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Registry } from '../registry/registry';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/toPromise';
import { ICategoryImages } from '../create-gift/ICategoryImages';
import { CartItem } from '../cart/cartItem';
import { URLSearchParams, QueryEncoder } from '@angular/http';
import { CreateGiftModel } from '../create-gift/create-gift-model';
import 'rxjs/add/operator/catch';
import { User } from '../user/auth.service';
import { GuestWish } from '../gift-wish/wish';
import { StarterRegistry, TemplateGift } from '../templates/starter-registry';

declare const fbq: any;

const destinationGifts = require('../templates/destination-gifts.json');
// import { CacheService, CacheStoragesEnum } from 'ng2-cache/ng2-cache';

@Injectable()
export class RegistryService {
 
  public firstGiftAssistantDone = false;
  public placeholderImages: Array<Gift>;
  public giftTitle: string;
  public destination: string;
  public selectedGift: Gift;
  public paymentName: string;
  public guestLast4: string;
  public createImages: ICategoryImages;
  public giftSelection: GiftSelection;
  public errorMessage: string;
  public guestPaymentStripeToken: string;
  public guestPaymentTotal: number;
  public guestpaymentGiftSubTotal: number;
  public scrollY: number;
  public numberOfGiftsBought: number;
  public lastEditUrl: string;
  public passwordOk = false;
  public hideGuestBanner = false;
  public _registry: Registry;
  public wish: GuestWish;
  public giftTemplates: Array<Gift>;

  public scrollToGift: string;
  wishSent = false;
  public isPreview = false;
  public symbol: string;
  public skipHelp = false;
  starterRegistries: StarterRegistry[];
  private readonly minAmounts: { [currency: string]: number } = {
    USD: 5,
    EUR: 5,
    GBP: 4,
    AUD: 8,
    CAD: 7,
    NZD: 8,
    CHF: 5,
    SEK: 55,
    NOK: 55,
    DKK: 35,
    SGD: 7,
    HKD: 40,
    JPY: 700,
  };

  private readonly maxAmounts: { [currency: string]: number } = {
    USD: 9000,
    EUR: 8500,
    GBP: 7500,
    AUD: 14000,
    CAD: 12000,
    NZD: 15000,
    CHF: 8000,
    SEK: 95000,
    NOK: 95000,
    DKK: 65000,
    SGD: 12000,
    HKD: 70000,
    JPY: 1000000,
  };

  constructor(private http: Http,
    private _configuration: ConfigurationService,
    private _registryFirebaseService: RegistryFirebaseService
  ) {
    this._registryFirebaseService.currentRegistry.subscribe(registry => {
      this._registry = registry;
    });

    this.giftTemplates = new Array<Gift>();
    this.loadGiftTemplates();
  }

  private emitToastSource = new Subject<ToastType>();
  private emitToastGenericSource = new Subject<string>();
  private emitWelcomeSource = new Subject<boolean>();
  private emitNextGift = new Subject<Gift>();
  // Observable string sources
  private emitHeaderSource = new Subject<string>();
  private emitShowHeaderSource = new Subject<string>();
  private emitShowTranslation = new Subject<boolean>();
  private emitHeaderPopupClosedSource = new Subject<string>();
  private emitShowCreatePopupSource = new Subject<Boolean>();
  private emitShowGenericPopupSource = new Subject<string>();
  
  private emitEditGiftFormUpdatesSource = new Subject<Gift>();
  // Observable string streams
  nextGiftEmitted$ = this.emitNextGift.asObservable();
  showTranslationEmitted$ = this.emitShowTranslation.asObservable();
  welcomeEmitted$ = this.emitWelcomeSource.asObservable();
  headerPopupClose$ = this.emitHeaderPopupClosedSource.asObservable();
  toastTypeEmitted$ = this.emitToastSource.asObservable();
  toastGenericEmitted$ = this.emitToastGenericSource.asObservable();
  headerTypeEmitted$ = this.emitHeaderSource.asObservable();
  showHeaderTypeEmitted$ = this.emitShowHeaderSource.asObservable();
  showCreateHelpPopup$ = this.emitShowCreatePopupSource.asObservable();
  showGenericPopup$ = this.emitShowGenericPopupSource.asObservable();
editGiftformUpdates = this.emitEditGiftFormUpdatesSource.asObservable();
  // Service message commands

  sendFbTrackEvent(eventType: string) {

      return;

  }

  setPreview(isPreview: boolean) {
    this.isPreview = isPreview;
  }

  getPortionsPricePerPortion(gift: Gift) {
    if (!gift.portions) {
      return null;
    }

    let total = gift.price / gift.portions;
    
    return total;

  }
  getWish():GuestWish {
    return this.wish;
  }

  checkIfPortionsAreGreaterThanZero(gift: Gift) {
    if (!gift.portions) {
      return false;
    }

    if (gift.portions > 0) {
      return true;
    }

    return false;
  }

  getPortionsRemaining(gift: Gift) {
    //;
    if (!gift.portions) {
      return null;
    }
    let pricePerPortion = this.getPortionsPricePerPortion(gift);
    let remaining = gift.remaining / pricePerPortion;
    return remaining;
  }

  emitCreateHelpPopup() {

    this.emitShowCreatePopupSource.next(true);
  }

  emitGiftFormUpdates(gift: Gift) {

    this.emitEditGiftFormUpdatesSource.next(gift);
  }

  emitGenricPopup(popupName: string) {
    ;
    const body = document.getElementsByTagName('body')[0];
    if (popupName) {

      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = 'auto';
    }
    this.emitShowGenericPopupSource.next(popupName);
  }


  loadGiftTemplates() {

    this.giftTemplates.push(this.generateGift('Road Trip', 0, '#A5AAAA', 'Near or far, there will be no better feeling than hitting the open road and exploring the great outdoors.', 'https://images.unsplash.com/photo-1556011222-6b328019e9bd', 'Road Trip'));
    this.giftTemplates.push(this.generateGift('Romantic Dinner', 200, '#99A7B1', 'A romantic dinner will be the perfect way to celebrate our big day and the love we share for one another.', 'https://images.unsplash.com/photo-1574926053821-79c5e338a933', 'Romantic Dinner'));
    this.giftTemplates.push(this.generateGift('Airbnb', 750, '#E4E0DD', 'We\'ll stay in an Airbnb to live like the locals and soak up the culture of the neighbourhood.', 'https://images.unsplash.com/photo-1547110287-71448271b1de', 'Airbnb'));
    this.giftTemplates.push(this.generateGift('Honeymoon Fund', 0, '#C8D7D6', 'We\'re so thankful to have everything we already need. So, we\'re skipping tradition and would love some help creating some new memories instead.', 'https://images.unsplash.com/photo-1544298903-35eee5a95b4d', 'Honeymoon'));
    this.giftTemplates.push(this.generateGift('Flights', 1000, '#D6D5D9', 'After the big day, we\'ll be jetting away on our adventure of a lifetime.', 'https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb', 'Flights'));
    this.giftTemplates.push(this.generateGift('Staycation', 0, '#C8D7D6', 'During this uncertain time, we\'ve decided to stay safe and spend our honeymoon nestled indoors.', 'https://images.unsplash.com/photo-1580562491167-b0865b9d234e', 'Staycation'));

    this.giftTemplates.push(this.generateGift('House Fund', 0, '#BEBCB8', 'We\'re grateful to have all that we need, so we\'re looking to the future and saving a deposit for our first home together.', 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7', 'House'));
    this.giftTemplates.push(this.generateGift('Charity', 250, '#C9B6A6', 'We plan to give back to those less fortunate by donating to our charity of choice.', 'https://images.unsplash.com/photo-1593526613712-7b4b9a707330', 'Charity'));
    this.giftTemplates.push(this.generateGift('Snorkelling', 150, '#CFF2F6', 'We\'re off to discover life under the sea with an adventurous couple\'s snorkelling experience.', 'https://images.unsplash.com/photo-1472715148636-92e348325950', 'Snorkelling'));
    this.giftTemplates.push(this.generateGift('Resort Stay', 0, '#D5CCCB', 'We\'ll be staying at the resort of our dreams and taking in some well-earned relaxation around the pool.', 'https://images.unsplash.com/photo-1601701119533-fde20cecbf4e', 'Resort'));
    this.giftTemplates.push(this.generateGift('Wine Tasting', 175, '#FCF7E3', 'There\'s always time for a glass of wine. We\'re so excited for our wine tasting experience.', 'https://images.unsplash.com/photo-1541971897566-308cf7ad0934', 'Wine'));
    this.giftTemplates.push(this.generateGift('Cooking Class', 150, '#5A636E', 'We\'ll be cooking up a storm with a romantic couple\'s cooking class.', 'https://images.unsplash.com/photo-1556909114-a1d34f47412c', 'Cooking'));

    this.giftTemplates.push(this.generateGift('Guided Tour', 125, '#A5AAAA', 'We can\'t wait to explore all the hidden treasures on our guided tour experience.', 'https://images.unsplash.com/photo-1599403275295-57bca684efd3', 'Tour'));
    this.giftTemplates.push(this.generateGift('Couple\'s Spa', 250, '#E2E4E3', 'A relaxing couple\'s spa day to help us unwind on our honeymoon.', 'https://images.unsplash.com/photo-1507652313519-d4e9174996dd', 'Spa'));
    this.giftTemplates.push(this.generateGift('Minimoon', 0, '#BEBCB8', 'We\'ll be escaping on a romantic minimoon to get some well-deserved rest and relaxation after the big day.', 'https://images.unsplash.com/photo-1541417904950-b855846fe074', 'Honeymoon'));
    this.giftTemplates.push(this.generateGift('Glamping', 600, '#2C3F43', 'We can\'t wait to gaze up at the stars while soaking in the best the outdoors has to offer.', 'https://images.unsplash.com/photo-1607020259898-bc4a1182ae75', 'Glamping'));
    this.giftTemplates.push(this.generateGift('Eco-moon', 0, '#BEBCB8', 'We\'re honeymooning the conscious way. We plan to limit our footprint by making it an eco-friendly trip.', 'https://images.unsplash.com/photo-1463343232537-7171a89c83f7', 'Eco'));
    this.giftTemplates.push(this.generateGift('Safari', 0, '#7A19F', 'We\'re going on a once-in-a-lifetime safari to experience nature\'s natural wonders.', 'https://images.unsplash.com/photo-1516026672322-bc52d61a55d5', 'Safari'));

    this.giftTemplates.push(this.generateGift('Adventure', 250, '#A5AAAA', 'We\'re off on our first big adventure as a married couple.', 'https://images.unsplash.com/photo-1562138072-66c663c09239', 'Adventure'));
    this.giftTemplates.push(this.generateGift('Transport', 100, '#2C3F43', 'We\'ll need to zip and zag between locations on our big trip.', 'https://images.unsplash.com/photo-1516733968668-dbdce39c4651', 'Transport'));
    this.giftTemplates.push(this.generateGift('Sunset Sail', 275, '#99A7B1', 'We\'re treating ourselves to a romantic sailing adventure that we\'ll never forget.', 'https://images.unsplash.com/photo-1526761122248-c31c93f8b2b9', 'Sunset Sail'));
    this.giftTemplates.push(this.generateGift('Happy Hour', 100, '#E4E0DD', 'It\'s five o\'clock somewhere! We\'d love you to help us kick off happy hour. Cocktail, anyone?', 'https://images.unsplash.com/photo-1536599424071-0b215a388ba7', 'Cocktails'));
    this.giftTemplates.push(this.generateGift('Hot Air Balloon', 350, '#BEBCB8', 'Up, up, and away! We\'re so excited to soar through the clouds on our dreamy Hot Air Balloon ride.', 'https://images.unsplash.com/photo-1558016183-68d5d7b8851b', 'Hot Air Balloon'));
    this.giftTemplates.push(this.generateGift('Bike Tour', 75, '#CFF2F6', 'With the wind blowing in our hair, we\'re off on a homeymoon biking tour adventure for two.', 'https://images.unsplash.com/photo-1456964513482-f21a68af77ee', 'Bike'));


  }

  generateGift(
    title,
    price: number,
    hex: string,
    description,
    imageUrl,
    category
  ): Gift {
    const gift = new Gift();
    gift.price = price;
    // if (location) {
    //   gift.location = location;
    // }
    gift.hidePrice = false;
    if (gift.price === 0) {
      gift.hidePrice = true;
      gift.price = 99999;
    }
    gift.hex = hex;
    gift.description = description;
    gift.title = title;
    gift.imageUrl = imageUrl;
    gift.category = category;
    gift.createdFromGiftAssistant = false;
    gift.editedAfterGiftAssistant = false;
    gift.giftTypeSelection = 'Experience';
    return gift;
    //  return JSON.parse(JSON.stringify(gift));
  }


  getGiftTemplates(): Promise<TemplateGift[]> {
   
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });

    let cachedStarterRegistries = localStorage.getItem('template-gifts');
    if(cachedStarterRegistries){
      return Promise.resolve(JSON.parse(cachedStarterRegistries));
    }

    return this.http.get(`${environment.firebase.clouldFunctionHost}/getMasterGiftTemplates`, options).toPromise()
      .then((res: any) => {
        try{
          
        const response: TemplateGift[] = res.json();
        localStorage.setItem('template-gifts', JSON.stringify(response));
        return Promise.resolve(response);
        }
        catch (ex) {
          return Promise.reject(ex);
        }
      })
  }


  getStarterRegistryTemplates() {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });


    let cachedStarterRegistries = localStorage.getItem('starter-registries');
    if(cachedStarterRegistries){
      return Promise.resolve(JSON.parse(cachedStarterRegistries));
    }
    return this.http.get(`${environment.firebase.clouldFunctionHost}/getStarterTemplates`, options)
      .subscribe((res: any) => {

        ;

        const response: StarterRegistry[] = res.json();
        this.starterRegistries = response;
        localStorage.setItem('starter-registries', JSON.stringify(this.starterRegistries));
        return response;


      })
  }

  getCountryStarterGifts(country: String){
    if(!this.starterRegistries){
      this.getStarterRegistryTemplates();
    }
    if(!this.starterRegistries){
      this.starterRegistries = destinationGifts;
    }


    let countryRegistrydata= this.starterRegistries.filter(x => x.country.toLowerCase() == country.toLowerCase());
    if (!countryRegistrydata || countryRegistrydata.length == 0){
      return;
    }
    let countryRegistry:StarterRegistry = countryRegistrydata[0];
    return countryRegistry.gifts;
  }
  getBankFieldTitles(country) {
;
    switch (country) {
      case 'AU':
        return {
          field1: 'Account name',
          field2: 'BSB',
          field3: 'Account number',
          field4: null,
        };

      case 'CA':
        return {
          field1: 'Transit number',
          field2: 'Institution number',
          field3: 'Account number',
          field4: null,
        };

      case 'HK':
        return {
          field1: 'Bank name',
          field2: 'Branch',
          field3: 'Account number',
          field4: null
        };
      case 'SG':
        return {
          field1: 'Bank name',
          field2: 'Branch',
          field3: 'Account number',
          field4: null
        };
        case 'MX':
          return {
            field1: 'Bank name',
            field2: 'CLABE',
            field3: null,
            field4: null
          };
      case 'GB':
        return {
          field1: 'Sort code',
          field2: 'Account number',
          field3: 'Account name',
          field4: 'IBAN'
        };
      case 'US':
        return {
          field1: 'Account holder name',
          field2: 'Routing number',
          field3: 'Account number',
          field4: null
        };
      case 'NZ':
        return {
          field1: 'Account number',
          field2: 'Account name',
          field3: null,
          field4: null,
        };
        case 'IL':
          return {
            field1: 'Account name',
            field2: 'Bank name',
            field3: 'Branch name',
            field4: 'Account Number',
          };
          case 'PE':
            return {
              field1: 'Beneficiary Name',
              field2: 'Bank Name',
              field3: 'Bank Account Number',
              field4: 'Interbank Account Code',
            };
      default:
        return {
          field1: 'IBAN',
          field2: 'Account name',
          field3: null,
          field4: null,
        };
    }
  }


  emitWelcomePopup() {
    this.emitWelcomeSource.next(true);
  }

  emmitNextGift(gift: Gift) {
    this.emitNextGift.next(gift);
  }

  emitHeaderUpdated(backgroundUrl: string) {
    this.emitHeaderSource.next(backgroundUrl);
  }
  setWishSent(sent: boolean) {
    this.wishSent = sent;
  }
  getWishSent(): boolean {
    return this.wishSent;
  }

  emitShowHeaderUpdated() {
    this.emitShowHeaderSource.next();
  }

  emitLanguageChange(showTranslation: boolean) {
    this.emitShowTranslation.next(showTranslation);
  }


  emitHeaderPopupClosed() {
    this.emitHeaderPopupClosedSource.next();
  }
  emitToastType(toastType: ToastType) {

    this.emitToastSource.next(toastType);
  }

  emitGenericToastMsg(text: string) {
    this.emitToastGenericSource.next(null);
    this.emitToastGenericSource.next(text);
  }


  setWebsiteUrl(gift: Gift){
    if (gift && gift.website){
      if (gift.website.startsWith('http://') || gift.website.startsWith('https://')){
      
      } else if (gift.website == 'https:/' || gift.website == 'http:/' ){
        gift.website = 'https://';

      }
      else {
        gift.website = 'https://' + gift.website
      }
      let domainUrl = (new URL(      gift.website));
      let domain = domainUrl.hostname.replace('www.','');
      gift.websiteLinkText = domain;
    }
    return gift;
  }
  // isLoggedIn(route: ActivatedRoute, user: User): boolean {
  //   let isLoggedIn = false;
  //   if (user == null) {
  //     return false;
  //   } else {
  //     route.data.subscribe(routeData => {
  //
  //       const routeIsLoggedIn: boolean = routeData['isLoggedIn'];
  //       if (routeIsLoggedIn === false) {
  //         return false;
  //       } else {
  //        return true;
  //       }
  //     });
  //   }
  // }

  getRegistryName(): string {
    return '';

    // const subdomainHref = location.hostname;
    // var parts = subdomainHref.split('.');

    // if (parts.length === 1) {
    //   return null;
    // }
    // var subdomain = parts.shift();
    // var upperleveldomain = parts.join('.');
    // return subdomain;
  }

  public GetGiftTitle(): string {
    return this.giftTitle;
  }


  public getColor(imageUrl: string): string {

    if (imageUrl) {
      const params = new URLSearchParams(imageUrl.split('#')[1]);
      const color = '#' + params.rawParams;
      return color;
    }
  }

  public cleanImageUrlRemoveHex(imageUrl: string): string {
    
    if(!imageUrl){
      return imageUrl;
    }
    const color = this.getColor(imageUrl);

    imageUrl = imageUrl.replace('?hex=' + color, '');
    return imageUrl;
  }



  UpdateHeaderBackgroundImage(imageUrl: string): Observable<any> {


    const body = '{\'ImageUrl\':\'\' + imageUrl + \'\'}';

    return this.http.post(this._configuration.baseUrl + '/api/registries/background', body, this.requestOptions())
      .map(response => {
        this.emitHeaderUpdated(imageUrl);
        return response.json();
      })
      .catch(this.handleError);

  }

  public SetGiftTitle(giftName: string) {
    this.giftTitle = giftName;
  }

  getGuestPaymentStripeToken(): string {
    return this.guestPaymentStripeToken;
  }

  GetImages(): Observable<ICategoryImages> {
    return this.http.get(this._configuration.baseUrl + '/api/gifts/images', this.requestOptions())
      .map((res) => res.json())
      .catch(this.handleError);
  }


  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json', 'Registry-Name': this.getRegistryName() });
    const options = new RequestOptions({ headers: headers, withCredentials: true });
    return options;
  }


  makePayment(registryId: string, stripeToken: string, email: string, cart: Array<CartItem>
    , names: string, guestWish: GuestWish): Observable<string> {


    const headers = new Headers({ 'Content-Type': 'application/json', 'hitchd-version': '1.0', 'hitchd-sec-header': registryId });
    const options = new RequestOptions({ headers: headers });
    const createModel = {
      registryId: registryId,
      email: email,
      stripeToken: stripeToken,
      cart: Array<any>(),
      name: names,
      wishContribution: guestWish.contribution,
      wishFromNames: guestWish.fromNames,
      wishText: guestWish.wishText,
      wishPartnerName: guestWish.partnersName,
      wishYourName: guestWish.yourName
    };
    if (!cart) {
      console.error('payment error no cart');
    }
    createModel.cart = new Array<any>();
    cart.forEach(cartItem => {
      createModel.cart.push(
        {
          title: cartItem.gift.title,
          giftId: cartItem.gift.id,
          price: cartItem.price
        }
      );
    });
    const bodyString = JSON.stringify(createModel);

    return this.http.post(environment.firebase.clouldFunctionHost + '/makePayment', bodyString, options).map((data: any) => {

      const paymentResponse: any = JSON.parse(data._body);
      return paymentResponse.paymentId;
    });
    // .catch(this.handleError);



  }



  private extractData(res: Response) {

    const body = res.json();
    return body || {};
  }




  private handleError(error: Response | any) {
    if (error.status === 400) {

      const errorText = error._body;
      return Observable.throw(errorText);
    }
    if (error.status === 404) {
      return Observable.throw('not found');

    }
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `$ {error.status} - $ {error.statusText || ''}$ {err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }



  getScrollY(): number {
    return this.scrollY;
  }

  addGift(newGift: CreateGiftModel): Observable<any> {

    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers, withCredentials: true });
    const bodyString = JSON.stringify(newGift); // Stringify payload

    return this.http.post(this._configuration.baseUrl + '/api/gifts', newGift, options).map(() => {

    }).catch(this.handleError);
  }


  setScrollY(scrollY: number) {
    this.scrollY = scrollY;
  }

  getSelected() {
    return this.selectedGift;
  }

  setGift(gift: Gift) {
    this.selectedGift = gift;
  }


  setGiftSelection(giftSelection: GiftSelection) {
    // this._cacheService.set('key', { 'some': 'data' }, { expires: Date.now() + 1000 * 60 * 60 });

    localStorage.setItem('giftSelection', JSON.stringify(giftSelection));
    this.giftSelection = giftSelection;
  }

  removeGift(gift: Gift) {
    return this.http.post(this._configuration.baseUrl + '/api/gifts/' + gift.id + '/deconste', null, this.requestOptions()).map((data: any) => {



    })
      .catch(this.handleError);


  }

  setGiftByGiftName(giftName: string, gifts: Gift[]) {

    this.selectedGift = gifts.find(x => x.friendlyUrl.toLowerCase() === giftName.toLowerCase());

  }

  getGiftSelectionForced(): GiftSelection {
    const giftSelection: GiftSelection = JSON.parse(localStorage.getItem('giftSelection'));
    return giftSelection;
  }

  getGiftSelection(giftName: string, gifts: Gift[], registry?: Registry): GiftSelection {

    const previousGiftSelection: GiftSelection = JSON.parse(localStorage.getItem('giftSelection'));
    if (previousGiftSelection && previousGiftSelection.gift
      && previousGiftSelection.gift.friendlyUrl.toLowerCase() === giftName.toLowerCase()) {
      this.giftSelection = previousGiftSelection;
    }

    if (!this.giftSelection) {
      this.giftSelection = new GiftSelection();
    }
    if (!this.giftSelection.gift) {
      this.giftSelection.gift = gifts.filter(x => x.friendlyUrl.toLowerCase() === giftName.toLowerCase())[0];
    }
    if (registry) {
      this.giftSelection.coupleServiceFee = registry.coupleFeePercent;
      this.giftSelection.guestServiceFee = registry.guestFeePercent;
    }

    if (registry && (registry.showRecommendedAmount || registry.hideRecommendedAmount === true)) {
      if (this.giftSelection.gift && !this.giftSelection.price) {
        this.giftSelection.price = 100;
        if (this.giftSelection.gift.remaining <= 100) {
          this.giftSelection.price = Math.round(this.giftSelection.gift.remaining / 2);
        }
      }
    }

    if (this.giftSelection === null || this.giftSelection === undefined) {

      if (this.selectedGift === null) {
        this.setGiftByGiftName(giftName, gifts);
      }

      const giftSelection = new GiftSelection();

      if (this.selectedGift === undefined) {
        return null;
      }

      giftSelection.gift = this.selectedGift;
      this.setGiftSelection(giftSelection);


      this.giftSelection.price = this.selectedGift.remaining;

    }
    this.giftSelection.isEditing = false;
    return this.giftSelection;
  }


  SetServiceFee(registry: Registry): void {

    const paymentGiftAmount: number = this.giftSelection.price;
    let serviceFee = 0;
    this.giftSelection.coupleServiceFee = 0;
    this.giftSelection.guestServiceFee = 0;


    if (registry.guestFeePercent === 0) {
      this.giftSelection.coupleServiceFee = serviceFee = paymentGiftAmount * registry.coupleFeePercent / 100;

    }

    else if (registry.coupleFeePercent === 0) {
      this.giftSelection.guestServiceFee = paymentGiftAmount * registry.guestFeePercent / 100;

    }

    else if (registry.coupleFeePercent === registry.guestFeePercent) {
      this.giftSelection.coupleServiceFee = paymentGiftAmount * registry.coupleFeePercent / 100;
      this.giftSelection.guestServiceFee = paymentGiftAmount * registry.guestFeePercent / 100;

    }

  }

  handlePopupScrollBars(router: Router) {
    router.events.subscribe((event) => {
      const body = document.getElementsByTagName('body')[0];
      if (
        router.url.endsWith('/welcome') ||
        router.url.endsWith('registry/intro') ||
        router.url.endsWith('registry/font') ||
        router.url.endsWith('registry/layout') ||
        router.url.endsWith('registry/share') ||
        router.url.endsWith('/contribution-success')



      ) {

        body.style.overflow = 'hidden';
      } else {

        // console.log('auto -rreg intro');
        body.style.overflow = 'auto';
        // this.showPopup = false;
      }

    });
  }

  SetNewServiceFee(registry: Registry) {

  }

  GetCreatePlaceHolders(images: ICategoryImages): Array<Gift> {

    this.placeholderImages = new Array<Gift>();


    this.AddPlaceHolderGift('', 'accommodation', '', '', images, null, 'sandysurf');
    return this.placeholderImages;
  }

  AddPlaceHolderGift(description: string, giftType: string, name: string, location: string, images: ICategoryImages, price: number, imagename) {
    const gift = new Gift();
    gift.paidAmount = 0;
    gift.paidPercent = 0;
    gift.description = description;
    gift.location = location;
    gift.type = giftType;
    gift.title = name;
    const image = images.categoryImages.filter(x => x.name.toLowerCase() === giftType)[0].images.filter(x => x.name.toLowerCase() === imagename)[0];
    gift.hex = image.hex;
    gift.imageUrl = image.imageUrl;
    gift.imageName = image.name;
    gift.price = price;
    this.placeholderImages.push(gift);
  }

  getMinAmountForCurrency(currency: string): number {
    return this.minAmounts[currency] || 5;
  }

  getMaxAmountForCurrency(currency: string): number {
    return this.maxAmounts[currency] || 9000;
  }

  isAmountBelowMinimum(amount: number, currency: string): boolean {
    const minAmount = this.getMinAmountForCurrency(currency || 'USD');
    return amount < minAmount;
  }

  isAmountAboveMaximum(amount: number, currency: string): boolean {
    const maxAmount = this.getMaxAmountForCurrency(currency || 'USD');
    return amount > maxAmount;
  }

  getMinAmountErrorMessage(registry: Registry): string {
    const minAmount = this.getMinAmountForCurrency(registry.currency);
    return `The amount is below the minimum ${registry.symbol}${minAmount} ${registry.currency} required to process a payment.`;
  }

  getMaxAmountErrorMessage(registry: Registry): string {
    const maxAmount = this.getMaxAmountForCurrency(registry.currency);
    return `Currently ${registry.symbol}${maxAmount} ${registry.currency} is the limit per contribution, you can make multiple contributions if you wish to gift more than this amount.`;
  }

}




// WEBPACK FOOTER //
// ./src/app/registry/registry.service.ts